import fetch from 'cross-fetch'
import { find } from 'lodash'
import { RSAA } from 'redux-api-middleware'

import * as ActionTypes from './types'
import countries from '../utils/countries'

export const hubSpotApi = () => (dispatch, getState) => {
  const {
    firstName,
    lastName,
    phone,
    country,
    email,
    privacyPolicyGmac,
    uuid,
    suid
  } = getState().user

  dispatch({
    [RSAA]: {
      types: [
        ActionTypes.HUBSPOT_REQUEST,
        {
          type: ActionTypes.HUBSPOT_SUCCESS,
          payload: (action, state, res) =>
            res.json().then(json => {
              return JSON.parse.json
            })
        },
        ActionTypes.HUBSPOT_FAILURE
      ],
      endpoint: `${process.env.REACT_APP_CAREER_HUBSPOT_AWS}`,
      method: 'POST',

      body: () => {
        const countryName = find(
          countries,
          countryObj => countryObj.code === country
        ).value

        const postData = {
          email: email,

          data: [
            { property: 'firstname', value: firstName },
            { property: 'lastname', value: lastName },
            { property: 'email', value: email },
            { property: 'mobilephone', value: phone },
            { property: 'country_of_residence', value: countryName },
            {
              property: 'global_opt_in_hubspot_',
              value: privacyPolicyGmac ? 'true' : ''
            },
            { property: 'gmat_lead_hubspot_', value: 'true' },
            { property: 'gmac_contact_type_hubspot_', value: 'true' },
            {
              property: 'career_explorer_results_url',
              value: `${window.location.origin}/report/${uuid}/${suid}`
            },
            {
              property: 'interactive_content_name',
              value: `global_career_explorer_tool`
            }
          ]
        }

        return JSON.stringify({ properties: postData })
      },
      fetch: async (...args) => fetch(...args)
    }
  })
}
